/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../../_metronic/helpers'
import * as TableUI from '../../../../components/Table/Table'
import {useFetchAccessMenu} from '../../../../hooks/useFetchAccessMenu'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {
  filterSelector,
  resetFilterNews,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {fetchNews, headers} from '../../../../services/fetcher'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import {ButtonGroups} from './ButtonGroups'
import RowFilter from './RowFilter'
import {StyledCard} from '../../../../components/StyledCard'
import {appSelector} from '../../../../redux/slices/appSlices'
import {HakAkses} from '../../../../components/mikro/getHakAkses'

type Props = {
  className: string
}

const TableNews: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {filterNews} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {accesses} = useFetchAccessMenu()
  const hakAkses = HakAkses()
  const [news, setNews] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [isUpload, setIsUpload] = useState(false)
  const [isError, setIsError] = useState(false)
  const [actived, setActived] = useState(false)

  var parse: any = require('html-react-parser')

  const rowNumber = useMemo(() => {
    const per = filterNews?.per_page ?? 5
    return page * per - per
  }, [filterNews, page])

  const deleteNews = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Cancel')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (confirm: any) => {
      if (confirm) {
        axios
          .delete(
            `${
              process.env.REACT_APP_PI_BACKEND_IP
            }/management/api/news/delete/${id}?credentials=${localStorage.getItem('credential')}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            }
          )
          .then((response) => {
            if (!response.data.error) {
              setIsUpload(true)
              swal({
                closeOnClickOutside: false,
                title: t('deleted successfully'),
                icon: 'success',
              })
              setActived(true)
            }
          })
          .catch((error) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.message),
              icon: 'error',
            })
          })
      }
    })
  }

  const handleEdit = (id: any) => {
    localStorage.setItem('idNews', id)
    navigate('/content/news/edit')
  }

  const handleResetTable = () => {
    dispatch(resetFilterNews())
  }

  const {RowLoader, RowEmptyData, RowErrorFetch} = useRowTable({
    colSpan: 6,
    onReloadTable: handleResetTable,
  })

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setLoading(true)

      const token = localStorage.getItem('token') as string
      const endpoint = `${url}&${objToParams(filterNews)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setNews(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const onFetchNews = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchNews(filterNews)
      .then((res) => {
        const data = res.data.data
        setNews(data.data)
        setPage(data.current_page)
        setNumberURL(data.links)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterNews])

  useEffect(() => {
    const getData = setTimeout(onFetchNews, 1000)
    return () => clearTimeout(getData)
  }, [onFetchNews])

  useEffect(() => {
    return () => {
      handleResetTable()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StyledCard>
      <ButtonGroups />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('Judul')}</th>
              <th>{t('Content')}</th>
              <th>{t('Flag')}</th>
              <th>Url</th>
              <th>{t('order-aksi')}</th>
            </tr>
          </TableUI.THead>

          <TableUI.TBody>
            <RowFilter />

            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : news.length === 0 ? (
              <RowEmptyData />
            ) : (
              news?.map((item, _index) => (
                <tr key={item?.id ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{item?.title}</td>
                  <td>{parse(item?.content)}</td>
                  <td>
                    <span className='d-block'>
                      <span
                        className={`badge ${
                          item?.flag === 1 ? 'badge-light-primary' : 'badge-light-danger'
                        }`}
                      >
                        {t(item?.flag === 1 ? 'Active' : 'Inactive')}
                      </span>
                    </span>
                  </td>
                  <td>{item?.url}</td>
                  <td>
                    <div className='d-flex justify-content-center'>
                      {hakAkses?.update && (
                        <button
                          onClick={() => handleEdit(item.id)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          title={t('ubah')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/pencil-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      )}
                      {hakAkses?.delete && (
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          title={t('Hapus')}
                          onClick={() => deleteNews(item.id)}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>
  )
}

export {TableNews}
